import {
  FormControl,
  FormLabel,
  GridItem,
  Input,
  Link,
  NumberDecrementStepper,
  NumberIncrementStepper,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  Text
} from '@chakra-ui/react';
import { FC, useEffect, useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { FormError } from '../form/FormError';
import StepBox from './stepBox';

const Parameters: FC = () => {
  const {
    register,
    watch,
    control,
    resetField,
    formState: { errors }
  } = useFormContext();

  const [scalingEnabled, setScalingEnabled] = useState(false);

  const watchScaling = watch(['scalingFloor', 'scalingCeiling']);
  const [floor, ceiling] = watchScaling;

  useEffect(() => {
    if (floor === ceiling) {
      resetField('scalingDays');
      setScalingEnabled(false);
    } else {
      setScalingEnabled(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [floor, ceiling]);

  return (
    <StepBox heading='5. Multiplier'>
      <GridItem colSpan={[1, 2, 3, 4]}>
        <Text color='gray.200'>
          The multiplier acts as a protection and scaling mechanism for rewards,{' '}
          <Link
            color='cyan.400'
            href='https://docs.crucible.wtf/launching-a-reward-program/reward-program-mechanics#multiplier'
            isExternal
          >
            read more here
          </Link>
          . Although it is not a requirement, it is recommended. Setting the
          floor and ceiling to the same number will disable the multiplier.
        </Text>
      </GridItem>

      <GridItem>
        <FormControl isRequired isInvalid={!!errors.scalingFloor}>
          <FormLabel>Scaling floor</FormLabel>
          <Controller
            control={control}
            name='scalingFloor'
            render={({ field: { onChange, value } }) => (
              <NumberInput
                value={value}
                onChange={(valueAsString) => onChange(valueAsString)}
                min={0}
              >
                <Input
                  as={NumberInputField}
                  id='amount'
                  type='number'
                  borderColor={'gray.300'}
                  placeholder='0'
                  {...register('scalingFloor')}
                />
                <NumberInputStepper>
                  <NumberIncrementStepper />
                  <NumberDecrementStepper />
                </NumberInputStepper>
              </NumberInput>
            )}
          />

          {!!errors.scalingFloor && (
            <FormError>{errors.scalingFloor.message}</FormError>
          )}
        </FormControl>
      </GridItem>

      <GridItem>
        <FormControl isRequired isInvalid={!!errors.scalingCeiling}>
          <FormLabel>Scaling ceiling</FormLabel>
          <Controller
            control={control}
            name='scalingCeiling'
            render={({ field: { onChange, value } }) => (
              <NumberInput
                value={value}
                onChange={(valueAsString) => onChange(valueAsString)}
                min={0}
              >
                <Input
                  as={NumberInputField}
                  id='amount'
                  type='number'
                  borderColor={'gray.300'}
                  placeholder='0'
                  {...register('scalingCeiling')}
                />
                <NumberInputStepper>
                  <NumberIncrementStepper />
                  <NumberDecrementStepper />
                </NumberInputStepper>
              </NumberInput>
            )}
          />
          {!!errors.scalingCeiling && (
            <FormError>{errors.scalingCeiling.message}</FormError>
          )}
        </FormControl>
      </GridItem>

      <GridItem>
        <FormControl
          isRequired
          isInvalid={!!errors.scalingDays}
          isDisabled={!scalingEnabled}
        >
          <FormLabel>Scaling days</FormLabel>
          <Controller
            control={control}
            name='scalingDays'
            render={({ field: { onChange, value } }) => (
              <NumberInput
                value={value}
                onChange={(valueAsString) => onChange(valueAsString)}
                min={0}
              >
                <Input
                  as={NumberInputField}
                  id='amount'
                  type='number'
                  borderColor={'gray.300'}
                  placeholder='0'
                  {...register('scalingDays')}
                />
                <NumberInputStepper>
                  <NumberIncrementStepper />
                  <NumberDecrementStepper />
                </NumberInputStepper>
              </NumberInput>
            )}
          />

          {!!errors.scalingDays && (
            <FormError>{errors.scalingDays.message}</FormError>
          )}
        </FormControl>
      </GridItem>
    </StepBox>
  );
};

export default Parameters;
